export const LOCAL_STORAGE_KEYS = {
  FAVORITE_LABELS: 'FAVORITE_LABELS',
  THEME: 'THEME',
  FAVORITES: 'FAVORITES',
};
